export type CdPermission = `${'P' | 'F' | 'H' | 'T'}:${'R' | 'W'}`;

export const hasPermission = (
  held: readonly string[],
  permission: CdPermission,
): boolean => held.includes(permission);
